// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-5b64af9d]{width:220px;text-align:left;padding-left:15px;color:#999;position:relative}.content .file_name[data-v-5b64af9d]{display:inline-block;color:#282729;width:180px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.content .icon-shangchuananniu[data-v-5b64af9d]{float:right;line-height:28px}.content .clear_span[data-v-5b64af9d]{position:absolute;top:0;right:16px;cursor:pointer;display:none}.content:hover .clear_span[data-v-5b64af9d]{display:block}", ""]);
// Exports
module.exports = exports;
